/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ShoppingWithMobileDescription_shoppingWith = {
    readonly description: string | null;
    readonly links: {
        readonly links: ReadonlyArray<{
            readonly url: string | null;
            readonly label: string | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"ShoppingWithSocial_shoppingWith">;
    readonly " $refType": "ShoppingWithMobileDescription_shoppingWith";
};
export type ShoppingWithMobileDescription_shoppingWith$data = ShoppingWithMobileDescription_shoppingWith;
export type ShoppingWithMobileDescription_shoppingWith$key = {
    readonly " $data"?: ShoppingWithMobileDescription_shoppingWith$data;
    readonly " $fragmentRefs": FragmentRefs<"ShoppingWithMobileDescription_shoppingWith">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ShoppingWithMobileDescription_shoppingWith",
  "type": "ShoppingWith",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "links",
      "storageKey": null,
      "args": null,
      "concreteType": "ShoppingWithLinks",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "links",
          "storageKey": null,
          "args": null,
          "concreteType": "ShoppingWithLink",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "url",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "label",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "ShoppingWithSocial_shoppingWith",
      "args": null
    }
  ]
};
(node as any).hash = 'a27aaf02bb46680058b73f2faceeef33';
export default node;
